import { GLOBAL_MESSAGE_CONFIG } from '@sd/shared';
import { Message } from '@sd/prism';

export const GlobalMessage = () => {
  const { level, message, title } = GLOBAL_MESSAGE_CONFIG;

  if (!message) return null;

  return (
    <Message color={level} title={title} className="mt-0 mx-0">
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </Message>
  );
};
